import axios from "../../actions/api";
import { bookMark, checkToken, getAuctionHistory, trackBuyer, updateAuctionHistory } from "../../actions/memberAction";
import parse from "html-react-parser";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import moment from "moment";
import React, { useEffect, useRef, useState, Suspense } from "react";
import algoliasearch from "algoliasearch";
import LoadingBar from "react-top-loading-bar";
import queryString from "query-string";

// Stylesheets
import "../../include/css/bootstrap.min.css";
import * as styles from "../../include/css/css-components/auctionDetails/AuctionDetail.module.css";

import "../../include/css/style.css";

import "../../include/css/dev.css";
import "../../include/css/product-gridview.css";
import "react-loading-skeleton/dist/skeleton.css";

// Utility and constants
import { imageUrl } from "../../actions/miscAction";
import { toast } from "react-toastify";
import {
  aiDescp,
  getAviationParts,
  getGenericParts,
  getPlaneCondition,
  getProductAnalytic,
  sendAuctionView,
} from "../../actions/dashboardAction";

import _ from "lodash";

// Components
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import Skeleton from "react-loading-skeleton";

// Components still loaded eagerly (if necessary, analyze further for lazy-loading)
import Slider from "react-slick";
import AlertSuccess from "../common/alertSuccess";
import { navigate } from "gatsby";
import Header from "../newDesign/header/header";

// Lazy-loaded components
const LoginForm = React.lazy(() => import("../loginForm"));
const PlaceBid = React.lazy(() => import("../placeBid"));
const AskQuestionModal = React.lazy(() => import("../askQuestionModal"));
const ImageLargeModal = React.lazy(() => import("../common/imageLargeModal"));
const Help = React.lazy(() => import("../help"));
const ChatModal = React.lazy(() => import("../chatModal"));
const LowerAskingPrice = React.lazy(() => import("../dashboard/dashboardHome/lowerAskingPriceModal"));
const Footer = React.lazy(() => import("../common/footer"));
const AviationTable = React.lazy(() => import("../aviation/aviationTable"));
const ShareWithMyBuyers = React.lazy(() => import("../shareWithBuyersModal"));
const PartsTable = React.lazy(() => import("../parts/partsTable"));
const WorldMap = React.lazy(() => import("../common/worldMap/worldMap"));

const emptyIcon = imageUrl("Folder.svg");
const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const pdffileImg = `${process.env.GATSBY_IMAGE_URL}pdf-file.svg`;
const docfileImg = `${process.env.GATSBY_IMAGE_URL}doc-file.svg`;
const sharekImg = `${process.env.GATSBY_IMAGE_URL}share.svg`;
const ProductDetails = ({ pageContext, location }) => {
  var {
    allCatagoryList,
    allManufacturers,
    allRegions,
    allCategories,
    allUpcomingBidDropDown,
    mainCategory,
    subCategory,
    selectedCat,
  } = pageContext;
  const [product, setProduct] = useState(
    pageContext?.product?.auction_id
      ? pageContext?.product
      : {
          auction_id: location?.pathname?.split("/")?.[4],
        },
  );

  const aucID = product.auction_id;
  const category_meta = selectedCat?.data;
  const loggedInUser =
    typeof window !== "undefined" && localStorage.getItem("token") ? JSON.parse(localStorage.getItem("member")) : "";

  const mimicMember = typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"));

  useEffect(() => {
    if (product.auction_id) {
      loadData();
    }
    if (aucID) {
      aiDescp(aucID, (res) => {
        if (res && res.status === 200) {
          setDescpCard(res.data);
        } else {
          navigate("/404");
        }
      });
    }
  }, []);

  const ref = useRef(null);
  const bidRef = useRef(null);
  const mobileBidRef = useRef(null);
  const [bidPlaced, setBidPlaced] = useState(false);
  const [thumbnailsRef, setThumbnailsRef] = useState(null);
  const [loadingMain, setLoadingMain] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [tab, setTab] = useState("detail");
  const [detail, setDetail] = useState({});
  const [productSliderRef, setProductSliderRef] = useState(null);
  const [show, setShow] = useState(false);
  const [cshow, setcShow] = useState(false);
  const [cat, setCat] = useState(false);
  const [subCat, setSubCat] = useState(false);
  const [catid, setCatid] = useState(false);
  const [subCatid, setSubCatid] = useState(false);

  const [yourBid, setYourBid] = useState({});
  const [bPos, setBPos] = useState({});

  const [listings, setListings] = useState([]);
  const [subListings, setSubListings] = useState([]);

  const [showShare, setShare] = useState(false);
  const [loader, setLoader] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [descpCard, setDescpCard] = useState({});

  const [items, setItems] = useState([]);
  const [imgShow, setImgShow] = useState(false);

  const [token, setToken] = useState(typeof window !== "undefined" && localStorage.getItem("token"));
  const [member, setMember] = useState(typeof window !== "undefined" && JSON.parse(localStorage.getItem("member")));
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [isWantedPipe, setIsWantedPipe] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  // const [socketClient, setSocket] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [loadingToken, setLoadingToken] = useState(false);

  const [askingPriceModal, setAskingPriceModal] = useState(false);
  const [action, setAction] = useState("");

  const [viewDetails, setViewDetails] = useState(false);
  const [showRFQ, setShowRFQ] = useState(false);
  const [sideBarValues, setSideBarValues] = useState({
    planeParts: [],
    planeCondition: [],
    manufacturerParts: [],
    planeModel: [],
  });
  const [isBookMarked, setIsBookMarked] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  const [showImageGallery, setShowImageGallery] = useState(false);
  const [showAddPart, setShowAddPart] = useState(false);
  const [showAviation, setShowAviation] = useState(false);

  const [showBuyerModal, setShowBuyerModal] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [analyticData, setAnalyticData] = useState(null);
  const [wantedListings, setWantedListings] = useState([]);
  const at_id = detail?.detail?.at_id || "";

  //state to update counter in header
  const [updateCount, setUpdateCount] = useState(false);

  const toggleBuyerModal = () => {
    setShowBuyerModal(!showBuyerModal);
  };

  const toggleAddPart = () => {
    setShowAddPart(!showAddPart);
  };

  const toggleImageGallery = () => {
    setShowImageGallery(!showImageGallery);
  };

  const toggleViewDetails = () => {
    setViewDetails((prev) => !prev);
  };

  const toggleRFQ = () => {
    setShowRFQ(!showRFQ);
  };

  const toggleAskingPrice = () => {
    setAskingPriceModal(!askingPriceModal);
  };

  useEffect(() => {
    const data = { ...sideBarValues };
    getPlaneCondition((res) => {
      if (res && res.status == 200) {
        data.planeCondition = res.data?.data;
      }
    });
    setSideBarValues(data);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isBuyNowRedirect = window.history && window.history.state && window.history.state.buyNowClicked;
      if (isBuyNowRedirect) {
        checkToken((res) => {
          if (res && res.status == 200) {
            toggleAskingPrice();
          }
        });
      }
    }
  }, [aucID]);

  useEffect(() => {
    if (typeof window !== "undefined" && localStorage.getItem("token") && aucID) {
      updateAuctionHistory(aucID, (res) => {});
      sendAuctionView(
        {
          auction_id: aucID,
        },
        (res) => {},
      );
      setLoadingHistory(true);
      getAuctionHistory(aucID, (res) => {
        if (res && res.status == 200) {
          setHistoryData(res?.data?.data);
          setLoadingHistory(false);
        }
      });
    }
  }, [aucID]);

  const toggleHelpModal = () => {
    setShowHelpModal(!showHelpModal);
  };

  const toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    setShowMobileFilter(!showMobileFilter);
  };
  const handleClosec = () => setcShow(false);
  const handleShowc = () => setcShow(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleImgShow = () => setImgShow(false);

  const d = new Date();
  let diff = d.getTimezoneOffset();
  function SplitTime(numberOfHours) {
    var Days = Math.floor(numberOfHours / 24);
    var Remainder = numberOfHours % 24;
    var Hours = Math.floor(Remainder);
    var Minutes = Math.floor(60 * (Remainder - Hours));
    return `${Days} ${Days > 1 ? "days" : "day"} ${Hours} ${Hours > 1 ? "hours" : "hour"} ${Minutes} ${
      Minutes > 1 ? "minutes" : "minute"
    }`;
  }

  useEffect(() => {
    if (location?.search) {
      const str = location.search;
      var index = str.indexOf("=");
      var [type, param] = [str.slice(0, index), str.slice(index + 1)];
      if (type === "?redirect") {
        const allSlugs = queryString?.parse(location.search);
        const slug = typeof window !== "undefined" && queryString.parse(atob(allSlugs?.redirect));
        if (token && slug) {
          if (
            slug?.page === "buyerARR" &&
            slug?.action == "increaseOffer" &&
            !loadingMain &&
            detail.detail &&
            detail.detail.status_id &&
            parseInt(detail.detail.status_id) < 4
          ) {
            setTab("bid");
          } else if (
            slug?.page === "buyerARR" &&
            slug?.action == "askQuestion" &&
            !loadingMain &&
            detail.detail &&
            !pageContext.archive
          ) {
            //In place of Ask A question modal adding for Chat Modal. Will need to replace in fututre
            // handleShow();
            setShowChatModal(true);
          } else if (
            slug?.page === "buyerARR" &&
            slug?.action == "share" &&
            !loadingMain &&
            detail.detail &&
            !pageContext.archive
          ) {
            setSelectedListing({ title: product?.title, auction_id: aucID });
            toggleBuyerModal();
          } else if (slug?.page === "shareBuyer" && slug?.action == "share" && slug?.hash) {
            const hash = slug?.hash;
            trackBuyer({ hash }, (res) => {
              if (res && res.status == 200) {
              }
            });
          } else if (slug?.page === "chatEmail" && slug?.action == "openChat") {
            setShowChatModal(true);
          }
        } else {
          typeof window !== "undefined" && localStorage.setItem("redirectUrl", window.location.href);
          navigate("/members/login");
        }
      }
    }
  }, [detail]);

  const lodD = async () => {
    const pipeIds = [1115, 1295, 1321, 1322, 1323, 1400, 1404, 1442, 1515, 1754];
    if (detail?.detail?.status_id && detail?.detail?.private && !loggedInUser?.name01) {
      typeof window !== "undefined" && localStorage.setItem("redirectUrl", window.location.href);
      navigate("/members/login");
    }
    if (detail && detail.detail && detail.detail.status_id < 3 && (!loggedInUser?.name01 || !detail.detail.private))
      window.location.href = "/404";
    if (detail && detail.detail && detail.detail.category_id) {
      if (detail.detail.status_id < 3 && (!loggedInUser?.name01 || !detail.detail.private))
        window.location.href = "/404";
      if (pipeIds.includes(detail.detail.category_id)) {
        setCat("Pipe");
        setCatid(9999);
        const records = await index.search("", {
          facetFilters: [`categories.lvl0:Pipe`],
          hitsPerPage: 20,
          page: 0,
        });
        setListings(records.hits.filter((item) => item.auction_id != aucID));
        const a = records.hits.filter((item) => item.auction_id === aucID);

        const isWanted = a && a.length && a[0].pipe && a[0].pipe.sale_type === "Wanted Pipe (Sell Pipe)";
        setIsWantedPipe(isWanted);
      } else {
        const find = subCategory;

        if (find) {
          setCat(mainCategory.description);
          if (mainCategory.description == "Aviation") {
            setShowHelp(true);
          } else if (mainCategory.description != "Aviation") {
            setShowHelp(false);
          }
          setSubCat(find.description);

          setCatid(mainCategory.category_id);
          setSubCatid(find.category_id);

          const records = await index.search("", {
            facetFilters: [`categories.lvl0:${mainCategory.description}_${mainCategory.category_id}`],

            hitsPerPage: 20,
            page: 0,
          });
          setListings(records.hits.filter((item) => item.auction_id != aucID));
          const records1 = await index.search("", {
            facetFilters: [
              `categories.lvl1:${mainCategory.description}_${mainCategory.category_id} > ${find.description}_${find.category_id}`,
            ],

            hitsPerPage: 20,
            page: 0,
          });

          setSubListings(records1.hits.filter((item) => item.auction_id != aucID));
        } else if (!subCat && !cat) {
          //alert(1);
          const mc = allCatagoryList.find((it) => it.node.category_id == detail.detail.category_id);
          if (mc) {
            if (mc?.node?.description && mc?.node?.description == "Aviation") {
              setShowHelp(true);
            } else if (mc?.node?.description && mc?.node?.description != "Aviation") {
              setShowHelp(false);
            }
            setCat(mc.node.description);
            setCatid(mc.node.category_id);
            const records = await index.search("", {
              facetFilters: [`categories.lvl0:${mc.node.description}_${mc.node.category_id}`],
              hitsPerPage: 20,
              page: 0,
            });
            setListings(records.hits.filter((item) => item.auction_id != aucID));
          }
        }
      }
    }
    if (at_id === 6 && mainCategory?.category_id) {
      const wantedListingRecords = await index.search("", {
        facetFilters: [`categories.lvl0:${mainCategory.description}_${mainCategory.category_id}`, `at_id:6`],
        hitsPerPage: 20,
        page: 0,
      });
      setWantedListings(wantedListingRecords.hits);
    }
  };

  useEffect(() => {
    lodD();
  }, [detail.detail]);

  const callbackBookmark = (res) => {
    if (res && res.status == 200) {
      setIsBookMarked(!isBookMarked);
      toast(<AlertSuccess message="Information  Saved" />);
    } else {
    }

    // setTimeout(() => setLoader(false), 2000);
    // loadData();
  };
  const loadData = async (hardRefresh = false) => {
    const headers = {
      "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
    };
    try {
      let url = `${process.env.GATSBY_API_URL}detail/${product.auction_id}`;
      if (hardRefresh) url = `${process.env.GATSBY_API_URL}detail/${product.auction_id}?hardRefresh=1`;
      //if (true) {
      setLoadingMain(true);
      const response1 = await axios({
        method: "get",
        headers,
        params: {
          member_id: member ? member.member_id : null,
          buyer_id: member ? member.buyer_id : null,
        },
        url,
      });

      setIsBookMarked(response1?.data?.wList);

      setDetail(response1.data);
      if (response1.data.bids && response1.data.bids.length > 0 && member.member_id) {
        response1.data.bids.sort(function (a, b) {
          return parseFloat(b.total_bid) - parseFloat(a.total_bid);
        });
        const yourBid = response1.data.bids.filter((ef) => ef.member_id === member.member_id);

        const bidsData = response1.data.bids;

        const bidsValues = bidsData.map((b) => parseFloat(b.total_bid).toFixed(2));
        const uniqueArray = bidsValues.filter(function (item, pos) {
          return bidsValues.indexOf(item) == pos;
        });

        uniqueArray.sort(function (a, b) {
          return b - a;
        });
        const bA = uniqueArray;
        const bidPosition = yourBid && yourBid.length > 0 && bA.indexOf(parseFloat(yourBid[0].total_bid).toFixed(2));

        setBPos(bidPosition + 1);
        setYourBid(yourBid[0]);
      }
      if (
        (response1?.data?.detail?.status_id < 3 && (!loggedInUser?.name01 || !response1?.data?.detail?.private)) ||
        _.isEmpty(response1?.data?.detail)
      ) {
        navigate("/404");
      } else {
        setLoadingMain(false);
      }
    } catch (e) {
      setLoadingMain(false);
    }
  };
  const productSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: thumbnailsRef,
  };
  const productSlider2 = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  const thumbnailSlider = {
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: productSliderRef,
    dots: false,
    arrows: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
    ],
  };

  useEffect(() => {
    setLoadingDetail(false);
    let items = [];
    !_.isEmpty(detail) &&
      detail.pics &&
      detail.pics.length > 0 &&
      detail.pics.map((ep) =>
        items.push({
          original:
            ep.s_path.substring(0, 5) === "https"
              ? `${ep.s_path}${ep.filename}_lp.${ep.suffix}`
              : `${process.env.GATSBY_MEDIA_URL}${ep.s_path}${ep.filename}_lp.${ep.suffix}`,
        }),
      );
    setItems(items);
  }, [detail]);

  useEffect(() => {
    const first = document.querySelector(".seller-description-scroll");
    const nodeList = first && first.querySelectorAll("table");
    if (nodeList) {
      Array.from(nodeList).map((item, i) => {
        var tbl = item;
        var parent = tbl.parentNode;
        var wrapper = document.createElement("div");
        wrapper.style.overflowX = "auto";
        parent.insertBefore(wrapper, tbl);
        wrapper.appendChild(tbl);
      });
    }
  });

  useEffect(() => {
    if (bidPlaced) {
      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "place_bid",
        placeBidTotal: +parseFloat(yourBid.total_bid).toFixed(2),
        placeBidPlace: bPos,
      });
      setBidPlaced(false);
    }
  }, [bidPlaced]);

  useEffect(() => {
    if (showHelp) {
      getAviationParts({ auctionId: aucID }, (res) => {
        if (res && res?.status == 200) {
          if (res?.data?.data?.length > 0) {
            setShowAviation(true);
          }
        }
      });
    } else {
      getGenericParts({ auctionId: aucID }, (res) => {
        if (res && res?.status == 200) {
          if (res?.data?.data?.length > 0) {
            setShowAviation(true);
          }
        }
      });
    }
  }, [showHelp]);

  const [queryData, setQueryData] = useState("");

  const categories = detail?.detail?.categories || [];

  useEffect(() => {
    if (loggedInUser?.name01 && aucID) {
      getProductAnalytic(aucID, (res) => {
        if (res && res.status === 200) {
          setAnalyticData(res.data);
        }
      });
    }
  }, [aucID]);

  return (
    <>
      {showChatModal && (
        <Suspense fallback={<div></div>}>
          <ChatModal
            auction_title={product?.title ? product?.title : detail?.title ? detail?.title : ""}
            userId={member.user_id}
            aucID={aucID}
            userName={member?.name01}
            loadingToken={loadingToken}
            show={showChatModal}
            setShowChatModal={setShowChatModal}
            setUpdateCount={setUpdateCount}
            updateCount={updateCount}
          />
        </Suspense>
      )}

      <LoadingBar color="#47ad1d" ref={ref} />
      <Header />
      {showHelp && !loadingDetail && (
        <Suspense fallback={<div></div>}>
          <Help
            auction_id={product?.auction_id}
            auction_title={product?.title}
            onHide={toggleHelpModal}
            show={showHelpModal}
          />
        </Suspense>
      )}

      <div
        class={`product-details-wrapper product-detail-page-wrapper `}
        onClick={(e) => {
          setShare(false);
        }}
      >
        <div class="product-details-container">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                {!loadingMain && detail.detail && detail.detail.status_id && parseInt(detail.detail.status_id) > 3 && (
                  <div
                    class={`${styles.pdCtaBox} pd-cta-box d-lg-none  pd-not-available d-flex flex-wrap`}
                    style={{ background: "#d10909" }}
                  >
                    <div class={`${styles.pdCtaTextBox} pd-cta-text-box flex-grow-1"`}>
                      <div class={`${styles.bidBox} bid-box ml-4`}>
                        <p class={` color-white`}>Attention</p>
                        <strong>This item is no longer available.</strong>
                      </div>
                    </div>
                  </div>
                )}
                {yourBid && yourBid.total_bid && (
                  <>
                    <div class={`${styles.pdCtaBox} pd-cta-box d-lg-none d-flex flex-wrap`}>
                      <div class={`${styles.pdCtaTextBox} pd-cta-text-box flex-grow-1`}>
                        <ul class={`${styles.bidList} bid-list d-flex flex-wrap`}>
                          <li class="flex-grow-1">
                            <div class={`${styles.bidBox} bid-box`}>
                              <p class={`color-white`}>Your {isWantedPipe ? "Quote" : "Bid"}</p>
                              <strong>
                                $
                                {parseFloat(Math.trunc(yourBid.total_bid))
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </strong>
                            </div>
                          </li>
                          <li class="flex-grow-1">
                            <div class={`${styles.bidBox} bid-box`}>
                              <p>Your Current Position</p>
                              <strong>{bPos}</strong>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class={`${styles.pdCtaBtn} pd-cta-btn pd-cta-btn ms-auto`}>
                        <a
                          href="javascript:void(0)"
                          class="btn btn-white btn-lg"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab("bid");
                            bidRef && bidRef.current && bidRef.current.scrollIntoView();
                          }}
                        >
                          Rebid
                        </a>
                      </div>
                    </div>
                    {bPos == 1 && (
                      <div class={`${styles.pdIntroBox} pd-intro-box d-lg-none high-bid-fix`}>
                        <h5>
                          Seller terms:{" "}
                          <span class={` red-text`}>
                            At this time you are the high bidder for this auction however the seller has the right to
                            reject any and all bids.{" "}
                          </span>
                        </h5>
                      </div>
                    )}
                  </>
                )}
                <div class={`${styles.productDetailsBox} product-details-box d-lg-flex flex-lg-wrap`}>
                  <div class={` pd-box  d-block d-lg-none pb-0`}>
                    <div className="d-flex align-items-center  justify-content-between">
                      <h6>{product?.category}</h6>
                    </div>

                    <h1 className="mob-title">
                      {product?.title ? product?.title : !loadingMain ? (detail?.title ? detail?.title : "") : ""}
                    </h1>
                    <p style={{ marginTop: "10px" }}>
                      {" "}
                      {category_meta?.content_overview ? category_meta?.content_overview : ""}
                    </p>

                    {/* {showHelp && !loadingDetail && (
                    <a className="count-style1 mt-2" href="javascript:void(0)" onClick={() => toggleHelpModal()}>
                      What parts are you looking for?
                    </a>
                  )} */}
                  </div>

                  <div class={` pd-sidebar`}>
                    <div class={` pd-sidebar-inner sticky-top non-sticly-top`}>
                      <div class="breadcrumb-container d-none d-lg-none">
                        <ol class="breadcrumb">
                          {detail?.categoryTree?.length > 0
                            ? detail?.categoryTree?.map((di, i) => (
                                <li class="breadcrumb-item">
                                  <a href={`/listings/index.cfm/catid/${di?.id}`}>{di?.description}</a>
                                </li>
                              ))
                            : ""}
                        </ol>
                      </div>
                      <div class={` product-slider-outer customized-slider `}>
                        {loadingMain ? (
                          <>
                            <Slider
                              {...productSlider}
                              className={`${styles.productSlider} product-slider mob-full-width `}
                              ref={(slider) => (slider = setProductSliderRef(slider))}
                            >
                              <li class={` product-slider-item`}>
                                <div class={`${styles.productImgBox} product-img-box`} style={{ paddingBottom: "0" }}>
                                  <Skeleton height={500} />
                                </div>
                              </li>
                            </Slider>
                            <Slider
                              {...thumbnailSlider}
                              className={`${styles.productThumbList} product-thumb-list thumbnails-slider mob-full-width add-custom-arrow ${styles.thumbnailsSlider} ${styles.addCustomArrow}`}
                              ref={(slider) => setThumbnailsRef(slider)}
                            >
                              {[1, 2, 3, 4].map((el) => (
                                <li class={styles.ptItem}>
                                  <div class={styles.ptImgBox}>
                                    <Skeleton height={100} />
                                  </div>
                                </li>
                              ))}
                            </Slider>
                          </>
                        ) : detail.pics && detail.pics.length > 0 ? (
                          <>
                            <Slider
                              {...productSlider}
                              className={`${styles.productSlider} product-slider mob-full-width `}
                              ref={(slider) => (slider = setProductSliderRef(slider))}
                            >
                              {detail.pics &&
                                detail.pics.map((ep, i) => (
                                  <li class={` product-slider-item`}>
                                    <div
                                      class={`${styles.productImgBox} product-img-box cursor-pointer `}
                                      onClick={() => {
                                        setPhotoIndex(i);
                                        setImgShow(!imgShow);
                                      }}
                                    >
                                      {ep.s_path.substring(0, 5) === "https" ? (
                                        <img src={`${ep.s_path}${ep.filename}_lp.${ep.suffix}`} alt={product?.title} />
                                      ) : (
                                        <img
                                          src={`${process.env.GATSBY_MEDIA_URL}${ep.s_path}${ep.filename}_lp.${ep.suffix}`}
                                          alt={product?.title}
                                        />
                                      )}
                                    </div>
                                  </li>
                                ))}
                            </Slider>
                            <Slider
                              {...thumbnailSlider}
                              className={`${styles.productThumbList} product-thumb-list thumbnails-slider mob-full-width add-custom-arrow ${styles.thumbnailsSlider}  ${styles.addCustomArrow}`}
                              ref={(slider) => setThumbnailsRef(slider)}
                            >
                              {detail.pics &&
                                detail.pics.map((ep, i) => (
                                  <li class={`${styles.ptItem} pt-item`}>
                                    <div
                                      class={` pt-img-box`}
                                      onClick={() => {
                                        setPhotoIndex(i);
                                        setImgShow(!imgShow);
                                      }}
                                    >
                                      {ep.s_path.substring(0, 5) === "https" ? (
                                        <img src={`${ep.s_path}${ep.filename}_lp.${ep.suffix}`} alt={ep.filename} />
                                      ) : (
                                        <img
                                          src={`${process.env.GATSBY_MEDIA_URL}${ep.s_path}${ep.filename}_lp.${ep.suffix}`}
                                          alt={ep.filename}
                                        />
                                      )}
                                    </div>
                                  </li>
                                ))}
                            </Slider>
                          </>
                        ) : (
                          <div className={`${styles.productSlider} product-slider  mob-full-width `}>
                            <div class={` product-slider-item`}>
                              <div class={`${styles.productImgBox} product-img-box cursor-pointer `}>
                                {" "}
                                <img
                                  src={
                                    product.image
                                      ? product.image
                                      : pageContext.archive && product.primaryPicture
                                      ? product.primaryPicture
                                      : product.primary_picture
                                      ? product.primary_picture.replace("_sp.", "_lp.")
                                      : detail?.primaryPicture
                                      ? detail?.primaryPicture
                                      : "https://media.salvex.com/auction/p/1830079/183007825_698229_lp.jpg"
                                  }
                                  alt={product?.title}
                                />
                              </div>
                            </div>{" "}
                          </div>
                        )}
                        <div className="d-none d-lg-block">
                          {analyticData?.askingPriceHistory?.length > 0 && analyticData?.reserve >= 0 ? (
                            <>
                              <p
                                style={{
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  paddingTop: "10px",
                                  marginBottom: "0px",
                                  marginTop: "40px",
                                }}
                              >
                                Proposed Asking Price History
                              </p>
                              <div className={`${styles.productSlider} product-slider dp_container`}>
                                {" "}
                                <img src={analyticData?.chartUrl} alt={"Proposed Asking Price History"} />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          {!loadingDetail && analyticData?.googleAnalytic?.length > 0 ? (
                            <>
                              <p
                                style={{
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  paddingTop: "10px",
                                  marginBottom: "0px",
                                  marginTop: "40px",
                                }}
                              >
                                Activity Per Country
                              </p>
                              <div className={`${styles.productSlider}  product-slider dp_container`}>
                                {" "}
                                {typeof window !== "undefined" ? (
                                  <WorldMap
                                    googleAnalyticData={analyticData?.googleAnalytic}
                                    id={"Activity Per Country"}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        {}
                      </div>
                      <div class="d-none d-lg-block"></div>
                    </div>
                  </div>
                  <div class={` pd-text-box`}>
                    {/* {!loadingMain && !product.image && (
                    <div class="pd-cta-box d-flex flex-wrap" style={{ background: "#d10909" }}>
                      <div class="pd-cta-text-box flex-grow-1">
                        <div class="bid-box">
                          <p class="color-white">Attention</p>
                          <strong>This item is no longer available.</strong>
                        </div>
                      </div>
                    </div>
                  )} */}

                    {!loadingMain &&
                      detail.detail &&
                      detail.detail.status_id &&
                      parseInt(detail.detail.status_id) > 3 && (
                        <div
                          class={`${styles.pdCtaBox} pd-cta-box rebid-listing-details pd-not-available d-flex flex-wrap`}
                          style={{ background: "#d10909" }}
                        >
                          <div class={`${styles.pdCtaTextBox} pd-cta-text-box flex-grow-1"`}>
                            <div class={`${styles.bidBox} bid-box ml-4`}>
                              <p class={` color-white`}>Attention</p>
                              <strong>This item is no longer available.</strong>
                            </div>
                          </div>
                        </div>
                      )}
                    {yourBid && yourBid.total_bid && (
                      <>
                        <div class={`${styles.pdCtaBox}  pd-cta-box rebid-listing-details  d-flex flex-wrap`}>
                          <div class={`${styles.pdCtaTextBox} pd-cta-text-box flex-grow-1`}>
                            <ul class={`${styles.bidList} bid-list d-flex flex-wrap`}>
                              <li class="flex-grow-1">
                                <div class={`${styles.bidBox} bid-box`}>
                                  <p class={` color-white`}>Your {isWantedPipe ? "Quote" : "Bid"}</p>
                                  <strong>
                                    $
                                    {parseFloat(Math.trunc(yourBid.total_bid))
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </strong>
                                </div>
                              </li>
                              <li class="flex-grow-1">
                                <div class={`${styles.bidBox} bid-box`}>
                                  <p>Your Current Position</p>
                                  <strong>{bPos}</strong>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class={`${styles.pdCtaBtn} pd-cta-btn ms-auto`}>
                            <a
                              href="javascript:void(0)"
                              class="btn btn-white btn-lg"
                              onClick={(e) => {
                                e.preventDefault();
                                setTab("bid");
                                bidRef && bidRef.current && bidRef.current.scrollIntoView();
                              }}
                            >
                              Rebid
                            </a>
                          </div>
                        </div>
                        {bPos == 1 && (
                          <div class={`${styles.pdIntroBox} pd-intro-box rebid-listing-details high-bid-fix `}>
                            <h5>
                              Seller terms:{" "}
                              <span>
                                At this time you are the high bidder for this auction however the seller has the right
                                to reject any and all bids.{" "}
                              </span>
                            </h5>
                          </div>
                        )}
                      </>
                    )}
                    <div class={`pd-box  d-none d-lg-block`} ref={bidRef}>
                      {loadingDetail ? (
                        <div class="breadcrumb-container">
                          <ol class="breadcrumb">
                            <Skeleton height={15} width={250} />
                          </ol>
                        </div>
                      ) : (
                        <div class="breadcrumb-container d-flex align-items-center  justify-content-between">
                          <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                              <a href={"/listings/index.cfm/catid/1001"}>All Listings</a>
                            </li>
                            {cat && (
                              <li class="breadcrumb-item " aria-current="page">
                                <a href={catid === 9999 ? `/pipe` : `/listings/index.cfm/catid/${catid}`}>{cat}</a>
                              </li>
                            )}
                            {subCat && (
                              <li class="breadcrumb-item " aria-current="page">
                                <a href={`/listings/index.cfm/catid/${subCatid}`}>{subCat}</a>
                              </li>
                            )}
                            {!loadingMain && !cat && !subCat && categories?.length > 0
                              ? categories?.reverse()?.map((ue) => (
                                  <li class="breadcrumb-item " aria-current="page">
                                    <a href={`/listings/index.cfm/catid/${ue?.category_id}`}>
                                      {ue?.description ? ue?.description : ""}
                                    </a>
                                  </li>
                                ))
                              : ""}
                          </ol>
                          {/* {showHelp && !loadingDetail && (
                          <a className="count-style1" href="javascript:void(0)" onClick={() => toggleHelpModal()}>
                            What parts are you looking for?
                          </a>
                        )} */}
                        </div>
                      )}
                      <div
                        class={` product-heading-box mt-0 d-flex align-items-baseline justify-content-between w-100`}
                      >
                        <h1 style={{ width: "60%", marginBottom: "0px" }}>
                          {product?.title ? product?.title : !loadingMain ? (detail?.title ? detail?.title : "") : ""}{" "}
                          {!loadingMain && !pageContext.archive && at_id !== 6 ? (
                            <a
                              style={{
                                textDecoration: "underline",
                                color: "#47ad1d",
                                fontWeight: "400",
                                fontSize: " 15px",
                              }}
                              href="javascript:void(0)"
                              onClick={() => {
                                setSelectedListing({ title: product.title, auction_id: aucID });
                                toggleBuyerModal();
                              }}
                            >
                              Share with Buyers
                            </a>
                          ) : (
                            ""
                          )}
                          {typeof window !== "undefined" &&
                            localStorage.getItem("member") &&
                            JSON.parse(localStorage.getItem("member")).sec_list == 100103 && (
                              <span style={{ fontWeight: "400", fontSize: " 15px" }}>
                                {" "}
                                |{" "}
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    color: "#47ad1d",
                                  }}
                                  target="_blank"
                                  href={
                                    process.env.GATSBY_APP_OLD_ADMIN_URL +
                                    "admin/_listings/views/_full.cfm?aucID=" +
                                    product.auction_id
                                  }
                                >
                                  Old Listing Backend
                                </a>{" "}
                                |{" "}
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    color: "#47ad1d",
                                  }}
                                  target="_blank"
                                  href={
                                    process.env.GATSBY_APP_NEW_ADMIN_URL + "listing-detail?id=" + product.auction_id
                                  }
                                >
                                  New Listing Backend
                                </a>
                              </span>
                            )}
                        </h1>

                        {(product.image ||
                          (pageContext.archive && product.primaryPicture) ||
                          !_.isEmpty(detail?.detail)) && (
                          <div
                            className="d-flex flex-wrap align-items-center justify-content-end"
                            style={{ width: "40%" }}
                          >
                            {/* <div class="w-100"> */}
                            <ul class={` pb-btn-group d-flex align-items-center justify-content-end`}>
                              {loadingDetail ? (
                                <li class={` pb-btn-item`}>
                                  <Skeleton height={15} width={150} />
                                </li>
                              ) : (
                                <li class={`pb-btn-item`}>
                                  {typeof window !== "undefined" && window.localStorage.getItem("token") && (
                                    <>
                                      <a
                                        href="javascript:voidd(0)"
                                        class={`pb-btn`}
                                        onClick={(e) => {
                                          setLoader(true);
                                          e.preventDefault();
                                          bookMark(
                                            {
                                              auction_id: product.auction_id,
                                            },
                                            callbackBookmark,
                                          );
                                        }}
                                      >
                                        {isBookMarked ? (
                                          <>
                                            <svg
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clip-path="url(#clip0_5571_58128)">
                                                <path
                                                  d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                                  stroke="black"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                                <path
                                                  d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                                  stroke="black"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                                <path
                                                  d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                                  stroke="black"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_5571_58128">
                                                  <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <span style={{ marginLeft: "4px" }}>Remove from Watchlist</span>
                                          </>
                                        ) : (
                                          <>
                                            {" "}
                                            <svg
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clip-path="url(#clip0_5_129)">
                                                <mask
                                                  id="mask0_5_129"
                                                  style={{ maskType: "luminance" }}
                                                  maskUnits="userSpaceOnUse"
                                                  x="0"
                                                  y="0"
                                                  width="20"
                                                  height="20"
                                                >
                                                  <path d="M20 0H0V20H20V0Z" fill="white" />
                                                </mask>
                                                <g mask="url(#mask0_5_129)">
                                                  <mask
                                                    id="mask1_5_129"
                                                    style={{ maskType: "luminance" }}
                                                    maskUnits="userSpaceOnUse"
                                                    x="0"
                                                    y="0"
                                                    width="20"
                                                    height="20"
                                                  >
                                                    <path d="M20 0H0V20H20V0Z" fill="white" />
                                                  </mask>
                                                  <g mask="url(#mask1_5_129)">
                                                    <path
                                                      d="M7.50003 18.3333C7.96026 18.3333 8.33336 17.9602 8.33336 17.4999C8.33336 17.0397 7.96026 16.6666 7.50003 16.6666C7.03979 16.6666 6.66669 17.0397 6.66669 17.4999C6.66669 17.9602 7.03979 18.3333 7.50003 18.3333Z"
                                                      stroke="black"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                    <path
                                                      d="M16.6667 18.3333C17.1269 18.3333 17.5 17.9602 17.5 17.4999C17.5 17.0397 17.1269 16.6666 16.6667 16.6666C16.2064 16.6666 15.8333 17.0397 15.8333 17.4999C15.8333 17.9602 16.2064 18.3333 16.6667 18.3333Z"
                                                      stroke="black"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                    <path
                                                      d="M0.833374 0.833252H4.16671L6.40004 11.9915C6.47624 12.3752 6.68496 12.7198 6.98966 12.9651C7.29436 13.2104 7.67562 13.3407 8.06671 13.3332H16.1667C16.5578 13.3407 16.939 13.2104 17.2437 12.9651C17.5484 12.7198 17.7571 12.3752 17.8333 11.9915L18.7141 9.18285M5.00004 4.99992H10"
                                                      stroke="black"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                  </g>
                                                  <path
                                                    d="M16 2V5M16 5V8M16 5H13M16 5H19"
                                                    stroke="black"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                  />
                                                </g>
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_5_129">
                                                  <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>{" "}
                                            <span>Add to Watchlist</span>
                                          </>
                                        )}
                                        {/* {loader ? (
                                          <b class={` btn-loader`}>
                                            <img src={loadingIcon} alt="loader" class={` loader-img fa-spin`} />
                                          </b>
                                        ) : (
                                          <>
                                            <img
                                              style={{
                                                height: detail.wList ? "auto" : "40px",
                                              }}
                                              src={detail.wList ? bookmarkImg : bookmarkIcon}
                                              alt="bookmarkIcon"
                                            />
                                          </>
                                        )} */}
                                      </a>
                                    </>
                                  )}
                                </li>
                              )}

                              {loadingDetail ? (
                                <li class={` pb-btn-item dropdown`}>
                                  <Skeleton height={15} width={150} />
                                </li>
                              ) : (
                                <li class={` pb-btn-item dropdown`}>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setShare(!showShare);
                                    }}
                                    href="dd"
                                    class={` pb-btn dropdown-toggle`}
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {" "}
                                    Share
                                    <img src={sharekImg} alt="Share" />
                                  </a>
                                  <div
                                    class={showShare ? "dropdown-menu show" : "dropdown-menu"}
                                    id="share"
                                    data-popper-placement="bottom-end"
                                    style={{
                                      position: "absolute",
                                      inset: "0px auto auto 55px",
                                      margin: "0px",
                                      transform: "translate3d(-204px, 38px, 0px)",
                                    }}
                                  >
                                    <ul class={`${styles.socialLinkList} social-link-list d-flex`}>
                                      <li>
                                        {" "}
                                        <TwitterShareButton
                                          className={`${styles.socialLink} social-link`}
                                          url={typeof window !== "undefined" && window.location.href}
                                          title={product.title}
                                          via="Salvex"
                                        >
                                          <a className={`${styles.socialLink} social-link`}>
                                            <FontAwesomeIcon icon={faXTwitter}></FontAwesomeIcon>
                                          </a>
                                        </TwitterShareButton>
                                      </li>
                                      {/* <li>
                                      <WhatsappShareButton
                                        className="social-link"
                                        url={typeof window !== "undefined" && window.location.href}
                                        quote={product.title}
                                      >
                                        <a class="social-link">
                                          <FontAwesomeIcon icon={faWhatsapp} />{" "}
                                        </a>
                                      </WhatsappShareButton>
                                    </li> */}
                                      <li>
                                        {" "}
                                        <FacebookShareButton
                                          className={`${styles.socialLink} social-link`}
                                          href={typeof window !== "undefined" && window.location.href}
                                          url={typeof window !== "undefined" && window.location.href}
                                          title={product.title}
                                        >
                                          {" "}
                                          <a className={`${styles.socialLink} social-link`}>
                                            <FontAwesomeIcon icon={faFacebookF} />{" "}
                                          </a>
                                        </FacebookShareButton>
                                      </li>
                                      <li>
                                        <EmailShareButton
                                          className={`${styles.socialLink} social-link`}
                                          subject={`Salvex | Your friend has just shared a listing | ${product.title}`}
                                          body={`Hey,\n Check out this listing, shared by your friend. \n \n`}
                                          url={typeof window !== "undefined" && window.location.href}
                                          quote={product.title}
                                          hashtag="#camperstribe"
                                        >
                                          {" "}
                                          <a className={`${styles.socialLink} social-link`}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                          </a>
                                        </EmailShareButton>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                      {
                        <div
                          className="showing-result-text new-text-styles detail-auction-text-fix search-margin-fix"
                          style={{ width: "70%" }}
                        >
                          <h2 style={{ fontSize: "1rem", marginBottom: "0px", fontWeight: "400", lineHeight: "1.5" }}>
                            {" "}
                            {category_meta?.content_overview ? category_meta?.content_overview : ""}
                          </h2>
                        </div>
                      }
                    </div>
                    {/* 
                  <div class="pd-box  d-block d-lg-none" ref={mobileBidRef}>
                    {loadingDetail ? <Skeleton height={10} width={150} /> : <h6>{product.category}</h6>}
                    {loadingDetail ? <Skeleton height={10} width={150} /> : <h3>{product.title}</h3>}
                  </div> */}
                    <div class={` pd-box`} ref={mobileBidRef}>
                      <div class={`nav  nav-tabs  custom-nav-tabs custom-tabs`}>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            setTab("detail");
                          }}
                          href="javascript:void(0)"
                          class={tab === "detail" ? "nav-link active" : "nav-link"}
                        >
                          {loadingDetail ? <Skeleton height={15} width={150} /> : <span>Item Details</span>}
                        </a>

                        {detail && detail.documents && detail.documents.length > 0 && (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              setTab("documents");
                            }}
                            href="javascript:void(0)"
                            class={tab === "documents" ? "nav-link active" : "nav-link "}
                          >
                            {loadingDetail ? <Skeleton height={15} width={150} /> : <span>Supporting Documents</span>}
                          </a>
                        )}

                        {at_id === 6 && (
                          <a
                            onClick={(e) => {
                              setLoadingToken(true);
                              setShowChatModal(true);

                              checkToken((res) => {
                                if (res && res.status == 200) {
                                  e.preventDefault();
                                  setLoadingToken(false);
                                }
                              });
                            }}
                            href="javascript:void(0)"
                            class={
                              tab === "wanted-contact" ? `nav-link has-place-bid active` : `nav-link  has-place-bid`
                            }
                          >
                            {loadingDetail ? (
                              <Skeleton height={15} width={150} />
                            ) : (
                              <span>Selling This Asset? Contact Us</span>
                            )}
                          </a>
                        )}

                        {!loadingMain &&
                          detail.detail &&
                          detail.detail.status_id &&
                          parseInt(detail.detail.status_id) < 4 &&
                          at_id !== 6 && (
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                if (token) {
                                  setLoadingToken(true);
                                  setTab("bid");
                                  checkToken((res) => {
                                    if (res && res.status == 200) {
                                      setLoadingToken(false);
                                    }
                                  });
                                } else {
                                  setTab("bid");
                                }
                              }}
                              href="javascript:void(0)"
                              class={
                                loadingDetail
                                  ? "nav-link"
                                  : tab === "bid"
                                  ? `nav-link has-place-bid active`
                                  : `nav-link  has-place-bid`
                              }
                            >
                              {loadingDetail ? (
                                <Skeleton height={15} width={150} />
                              ) : (
                                <span>{isWantedPipe ? "Send a Quote" : "Place a Bid"}</span>
                              )}
                            </a>
                          )}
                      </div>
                      <div class={` tab-pane-content-box`}>
                        {tab === "bid" && (
                          <div class={` tab-pane-form`}>
                            {token ? (
                              detail.detail && detail.detail.status_id && parseInt(detail.detail.status_id) > 4 ? (
                                <div class={` npc-text yellow-bg  d-flex align-items-center flex-wrap`}>
                                  The auction has ended.
                                </div>
                              ) : (
                                <Suspense fallback={<div></div>}>
                                  <PlaceBid
                                    product={product}
                                    loadData={loadData}
                                    setBidPlaced={setBidPlaced}
                                    handleShow={handleShow}
                                    detail={detail}
                                    isWantedPipe={isWantedPipe}
                                    loadingToken={loadingToken}
                                  />
                                </Suspense>
                              )
                            ) : (
                              <>
                                <h4>Login</h4>
                                <Suspense fallback={<div></div>}>
                                  <LoginForm
                                    setToken={setToken}
                                    setTab={setTab}
                                    tab={tab}
                                    toggleAskingPrice={toggleAskingPrice}
                                    action={action}
                                    setAction={setAction}
                                    loadingToken={loadingToken}
                                  />
                                </Suspense>
                              </>
                            )}
                          </div>
                        )}

                        {tab === "documents" && (
                          <ul class={` doc-list d-flex flex-wrap align-items-center`}>
                            {detail &&
                              detail.documents &&
                              detail.documents.length > 0 &&
                              detail.documents.map((f, i) => (
                                <li class="doc-item">
                                  <a
                                    href={process.env.GATSBY_MEDIA_URL + f.filename}
                                    target="_blank"
                                    class={` doc-img-box d-flex align-items-center justify-content-center cursor-pointer`}
                                  >
                                    <img src={f.type === "pdf" ? pdffileImg : docfileImg} alt="docfileImg" />
                                  </a>
                                  <p>{f.name}</p>
                                </li>
                              ))}
                          </ul>
                        )}

                        {tab === "detail" && (
                          <table class={` table  table-borderless`}>
                            {loadingMain ? (
                              [1, 2, 3, 4, 5].map((sk) => (
                                <tbody>
                                  <tr class="mb-3">
                                    <td>
                                      <Skeleton height={20} width={600} />
                                    </td>
                                  </tr>
                                </tbody>
                              ))
                            ) : (
                              <tbody>
                                <tr>
                                  <td style={{ width: "200px" }}>
                                    {loadingDetail ? <Skeleton height={15} width={100} /> : "ID"}
                                  </td>

                                  {!loadingDetail && <td>:</td>}
                                  <td className=" d-flex  align-items-center justify-content-start">
                                    {loadingDetail ? <Skeleton height={15} width={100} /> : product.auction_id}
                                    {at_id === 6 && (
                                      <div class=" d-flex  align-items-center ask-gp" style={{ marginLeft: "15px" }}>
                                        <a
                                          style={{ marginRight: "10px" }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (token) {
                                              setLoader(true);
                                              e.preventDefault();
                                              bookMark(
                                                {
                                                  auction_id: product.auction_id,
                                                },
                                                callbackBookmark,
                                              );
                                            } else {
                                              typeof window !== "undefined" &&
                                                localStorage.setItem("redirectUrl", window.location.href);
                                              navigate("/members/login");
                                            }
                                          }}
                                          href="javascript:void(0)"
                                          class="grid7-badge watch-listing small-place-btn-font fc-white"
                                        >
                                          {isBookMarked ? "ADDED TO WATCHLIST" : "WATCH LISTING"}
                                        </a>
                                        {detail.detail &&
                                        !pageContext.archive &&
                                        detail?.detail?.status_id !== 5 &&
                                        detail?.detail?.name01 ? (
                                          <>
                                            {" "}
                                            <a
                                              style={{ marginRight: "10px" }}
                                              onClick={(e) => {
                                                setLoadingToken(true);
                                                setShowChatModal(true);
                                                checkToken((res) => {
                                                  if (res && res.status == 200) {
                                                    e.preventDefault();
                                                    setLoadingToken(false);
                                                  }
                                                });
                                              }}
                                              href="javascript:void(0)"
                                              class="grid7-badge small-place-btn-font contact-team-btn fc-white"
                                            >
                                              CONTACT SALVEX TEAM
                                            </a>{" "}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                                {at_id !== 6 && (
                                  <>
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Seller"}
                                      </td>

                                      {!loadingDetail && <td>:</td>}
                                      <td>
                                        {loadingDetail ? (
                                          <Skeleton height={15} width={100} />
                                        ) : loggedInUser && analyticData?.display_seller_detail !== 0 ? (
                                          <span>{analyticData?.seller_company_name}</span>
                                        ) : loggedInUser && analyticData?.display_seller_detail === 0 ? (
                                          <span>Confidential</span>
                                        ) : (
                                          <span>
                                            Confidential{" "}
                                            <a
                                              href="javascript:void(0)"
                                              className="link-item"
                                              onClick={() => {
                                                typeof window !== "undefined" &&
                                                  localStorage.setItem("redirectUrl", window.location.href);
                                                navigate("/members/login");
                                              }}
                                              style={{
                                                textDecoration: "underline",
                                                color: "#47ad1d",
                                                fontWeight: "400",
                                                fontSize: " 15px",
                                              }}
                                            >
                                              (Login to view seller info)
                                            </a>
                                          </span>
                                        )}
                                        {analyticData?.display_seller_detail === 3 ||
                                        analyticData?.display_seller_detail === 2 ? (
                                          <img
                                            className="seller-logo"
                                            src={
                                              process.env.GATSBY_MEDIA_URL +
                                              "/co/logos/" +
                                              analyticData?.picture?.proc_logo
                                            }
                                            alt=""
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Seller Industry"}
                                      </td>

                                      {!loadingDetail && <td>:</td>}
                                      <td>
                                        {loadingDetail ? (
                                          <Skeleton height={15} width={100} />
                                        ) : loggedInUser ? (
                                          <span>{analyticData?.seller_industry}</span>
                                        ) : (
                                          <span>
                                            Confidential{" "}
                                            <a
                                              href="javascript:void(0)"
                                              className="link-item"
                                              onClick={() => {
                                                typeof window !== "undefined" &&
                                                  localStorage.setItem("redirectUrl", window.location.href);
                                                navigate("/members/login");
                                              }}
                                              style={{
                                                textDecoration: "underline",
                                                color: "#47ad1d",
                                                fontWeight: "400",
                                                fontSize: " 15px",
                                              }}
                                            >
                                              (Login to view seller industry)
                                            </a>
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                {detail?.detail?.asking_price &&
                                detail?.detail?.asking_price > 0 &&
                                detail?.detail?.asking_price_feature ? (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "Current Asking Price"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        <div
                                          class="grid7-offer d-flex  align-items-center w-75"
                                          style={{ marginBottom: "0px", padding: "13px 10px", flexWrap: "wrap" }}
                                        >
                                          <div class="offer-total">
                                            ${" "}
                                            {parseFloat(Math.trunc(detail?.detail?.asking_price))
                                              .toString()
                                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                          </div>
                                          {}
                                          {!pageContext.archive && at_id !== 6 && detail?.detail?.status_id !== 5 ? (
                                            <div
                                              class="offer-badge cursor-pointer buy-now-btn"
                                              style={{
                                                marginTop: "0px",
                                                marginLeft: "10px",
                                                padding: "8px",
                                                lineHeight: "1.6",
                                                fontWeight: "600",
                                              }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (!token) {
                                                  setAction("public-asking-price");
                                                  setTab("bid");
                                                } else {
                                                  setLoadingToken(true);
                                                  toggleAskingPrice();
                                                  checkToken((res) => {
                                                    if (res && res.status == 200) {
                                                      setLoadingToken(false);
                                                    }
                                                  });
                                                }
                                              }}
                                            >
                                              Buy Now or Counter Offer
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}
                                {detail.wholesaleValue > 0 && (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        "Original Wholesale Value"
                                      )}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        <div
                                          class="grid7-highlighted-content w-75"
                                          style={{ marginBottom: "0px", padding: "10px" }}
                                        >
                                          <div class="g-h-total">
                                            <span style={{ fontWeight: "600" }}>
                                              $
                                              {parseFloat(Math.trunc(detail.wholesaleValue))
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td style={{ width: "200px" }}>
                                    {loadingDetail ? <Skeleton height={15} width={100} /> : "Quantity"}
                                  </td>
                                  {!loadingDetail && <td>:</td>}
                                  <td>
                                    {loadingDetail ? (
                                      <Skeleton height={15} width={100} />
                                    ) : detail.detail ? (
                                      `${detail?.detail?.quantity ? detail?.detail?.quantity : ""} ${
                                        detail?.detail?.unit ? detail?.detail?.unit : "Units"
                                      }`
                                    ) : product.quantity ? (
                                      product.quantity
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                                {(product.image || (pageContext.archive && product.primaryPicture)) &&
                                  detail.detail &&
                                  detail.detail.mfrdes && (
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Manufacturer"}
                                      </td>
                                      {!loadingDetail && <td>:</td>}
                                      <td>
                                        <p className="auction_detail_mfr">
                                          {loadingDetail ? (
                                            <Skeleton height={15} width={100} />
                                          ) : detail.detail && detail.detail.mfr ? (
                                            <>
                                              {product.make
                                                ? product.make
                                                : detail?.detail?.mfrdes
                                                ? detail?.detail?.mfrdes
                                                : ""}{" "}
                                              <a
                                                class="green-text text-decoration-underline"
                                                href={`/listings/index.cfm/mfr/${detail.detail.mfr}`}
                                              >
                                                {" "}
                                                View more items from this manufacturer
                                              </a>
                                            </>
                                          ) : product.make ? (
                                            product.make
                                          ) : (
                                            "N/A"
                                          )}
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                {detail && detail.detail && (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "Condition"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td style={{ verticalAlign: "top" }}>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        <div className="d-flex " style={{ flexDirection: "column" }}>
                                          {detail && detail.conditionType ? (
                                            <div
                                              className="grid7-badge"
                                              style={{ width: "fit-content", marginRight: "5px" }}
                                            >
                                              {detail && detail.conditionType ? detail.conditionType : ""}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <span
                                            class={` sustainability-product-detail-fix dot-list-fix dot-list customized-bullet table-seller-detail  `}
                                            id="sustainability-product-detail-style"
                                          >
                                            <HTMLEllipsis
                                              unsafeHTML={detail && detail.detail && detail.detail.condition}
                                              maxLine="20"
                                              basedOn="letters"
                                            />
                                          </span>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )}{" "}
                                {at_id !== 6 && (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : isWantedPipe ? (
                                        "Number of Quotes"
                                      ) : (
                                        "# of Bids"
                                      )}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td className="d-flex place-bid-td">
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        <div
                                          class="grid7-offer d-flex  align-items-center w-75 place-a-bid-container ask-question-grid"
                                          style={{
                                            marginBottom: "0px",
                                            padding: "13px 10px",
                                            flexWrap: "wrap",
                                            paddingLeft: "0px",
                                          }}
                                        >
                                          <div class=" d-flex  align-items-center ">
                                            <div className="detail-bid-count" style={{ marginRight: "10px" }}>
                                              {detail?.bidsCount > 0
                                                ? detail?.bidsCount == 1
                                                  ? "1 Bid"
                                                  : detail?.bidsCount + " Bids"
                                                : "0 Bid"}
                                            </div>
                                            {!pageContext.archive && detail?.detail?.status_id !== 5 ? (
                                              <div
                                                style={{ marginRight: "10px" }}
                                                class="offer-badge offer-btn-place-bid cursor-pointer small-place-btn-font"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  if (token) {
                                                    setLoadingToken(true);
                                                    setTab("bid");
                                                    checkToken((res) => {
                                                      if (res && res.status == 200) {
                                                        setLoadingToken(false);
                                                      }
                                                    });
                                                  } else {
                                                    setTab("bid");
                                                  }
                                                }}
                                              >
                                                {isWantedPipe ? "Send a Quote" : "PLACE A BID"}
                                              </div>
                                            ) : (
                                              ""
                                            )}{" "}
                                          </div>
                                          <div class=" d-flex  align-items-center ask-gp">
                                            {/* {detail.detail &&
                                          !pageContext.archive &&
                                          detail?.detail?.status_id !== 5 &&
                                          detail?.detail?.name01 ? (
                                            <>
                                              {" "}
                                              <a
                                                style={{ marginRight: "10px" }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  if (token) {
                                                    setLoadingToken(true);
                                                    handleShow();
                                                    checkToken((res) => {
                                                      if (res && res.status == 200) {
                                                        setLoadingToken(false);
                                                      }
                                                    });
                                                  } else {
                                                    typeof window !== "undefined" &&
                                                      localStorage.setItem("redirectUrl", window.location.href);
                                                     window.location.assign(process.env.GATSBY_MAIN_SITE_REDIRECT +"/members/login");
                                                  }
                                                }}
                                                href="javascript:void(0)"
                                                class="grid7-badge small-place-btn-font"
                                              >
                                                ASK A QUESTION
                                              </a>{" "}
                                            </>
                                          ) : (
                                            ""
                                          )} */}

                                            <a
                                              style={{ marginRight: "10px" }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (token) {
                                                  setLoader(true);
                                                  e.preventDefault();
                                                  bookMark(
                                                    {
                                                      auction_id: product.auction_id,
                                                    },
                                                    callbackBookmark,
                                                  );
                                                } else {
                                                  typeof window !== "undefined" &&
                                                    localStorage.setItem("redirectUrl", window.location.href);
                                                  navigate("/members/login");
                                                }
                                              }}
                                              href="javascript:void(0)"
                                              class="grid7-badge watch-listing small-place-btn-font fc-white"
                                            >
                                              {isBookMarked ? "ADDED TO WATCHLIST" : "WATCH LISTING"}
                                            </a>
                                            {detail.detail &&
                                            !pageContext.archive &&
                                            detail?.detail?.status_id !== 5 &&
                                            detail?.detail?.name01 ? (
                                              <>
                                                {" "}
                                                <a
                                                  style={{ marginRight: "10px" }}
                                                  onClick={(e) => {
                                                    setLoadingToken(true);
                                                    setShowChatModal(true);
                                                    checkToken((res) => {
                                                      if (res && res.status == 200) {
                                                        e.preventDefault();
                                                        setLoadingToken(false);
                                                      }
                                                    });
                                                  }}
                                                  href="javascript:void(0)"
                                                  class="grid7-badge small-place-btn-font contact-team-btn fc-white"
                                                >
                                                  CONTACT SALVEX TEAM
                                                </a>{" "}
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {at_id !== 6 ? (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "Product Location"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : detail?.loc_sec == 0 ? (
                                        detail?.location1
                                      ) : detail?.loc_sec == 1 ? (
                                        detail?.location2
                                      ) : detail?.loc_sec == 2 ? (
                                        detail?.location3
                                      ) : detail?.loc_sec == 3 ? (
                                        <div dangerouslySetInnerHTML={{ __html: detail?.location4?.toString() }} />
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "Target Purchase Region"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : detail?.loc_sec == 0 ? (
                                        detail?.location1
                                      ) : detail?.loc_sec == 1 ? (
                                        detail?.location2
                                      ) : detail?.loc_sec == 2 ? (
                                        detail?.location3
                                      ) : detail?.loc_sec == 3 ? (
                                        <div dangerouslySetInnerHTML={{ __html: detail?.location4?.toString() }} />
                                      ) : (
                                        <span>Global</span>
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {pageContext?.product?.auction_id && at_id !== 6 ? (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "End Time"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        <p
                                          class={
                                            detail.detail
                                              ? detail.detail.end_date
                                              : product.end_date &&
                                                moment(detail.detail ? detail.detail.end_date : product.end_date).diff(
                                                  moment(),
                                                  "hours",
                                                ) < 24
                                              ? `red-text`
                                              : ""
                                          }
                                        >
                                          {!product.image
                                            ? "Closed"
                                            : product.end_date === "Surplus Inventory" || product.end_date === ""
                                            ? isWantedPipe
                                              ? "Quote As Soon As Possible"
                                              : "Bid As Soon As Possible"
                                            : moment(detail.detail ? detail.detail.end_date : product.end_date)
                                                .add({ minute: diff })
                                                .format("MMM-D-YY, h:mm:ss A") + " CST"}{" "}
                                        </p>
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}
                                {(() => {
                                  const apiDate = detail?.detail?.end_date || product?.end_date;
                                  const baseDate = moment(apiDate, moment.ISO_8601, true);

                                  // Ensure date is valid
                                  if (!baseDate.isValid()) return null;

                                  const adjustedDate = baseDate.add(diff, "minutes");

                                  // Ensure date is not in the past and `at_id === 6`
                                  if (adjustedDate.isBefore(moment()) || at_id !== 6) return null;

                                  return (
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Fulfilment Deadline"}
                                      </td>
                                      {!loadingDetail && <td>:</td>}
                                      <td>
                                        {loadingDetail ? (
                                          <Skeleton height={15} width={100} />
                                        ) : (
                                          <p className={baseDate.diff(moment(), "hours") < 24 ? "red-text" : ""}>
                                            {adjustedDate.format("MMM-D-YY, h:mm:ss A") + " CST"}
                                          </p>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })()}
                                {product.end_date !== "Surplus Inventory" &&
                                  product.end_date !== "" &&
                                  product.image &&
                                  moment(detail.detail ? detail.detail.end_date : product.end_date).diff(
                                    moment(),
                                    "hours",
                                  ) > 0 && (
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Time Remaining"}
                                      </td>
                                      {!loadingDetail && <td>:</td>}
                                      <td>
                                        {loadingDetail ? (
                                          <Skeleton height={15} width={100} />
                                        ) : (
                                          <p
                                            class={
                                              moment(detail.detail ? detail.detail.end_date : product.end_date).diff(
                                                moment(),
                                                "hours",
                                              ) > 24
                                                ? ""
                                                : `red-text`
                                            }
                                          >
                                            {SplitTime(
                                              moment(detail.detail ? detail.detail.end_date : product.end_date).diff(
                                                moment(),
                                                "minutes",
                                              ) / 60,
                                            )}
                                          </p>
                                        )}
                                      </td>
                                    </tr>
                                  )}
                                {/* <tr>
                                  <td>{loadingDetail ? <Skeleton height={15} width={100} /> : "Trader"}</td>
                                  {!loadingDetail && <td>:</td>}
                                  <td>
                                    {loadingDetail ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <>
                                        {product.trader}{" "}
                                        {detail.detail && detail.detail.phone ? detail.detail.phone : detail.c_phone}
                                        {"  "}
                                        {detail.detail && !pageContext.archive ? (
                                          <>
                                            {" "}
                                            <a
                                              style={{ marginRight: "12px" }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (token) {
                                                  setLoadingToken(true);
                                                  handleShow();
                                                  checkToken((res) => {
                                                    if (res && res.status == 200) {
                                                      setLoadingToken(false);
                                                    }
                                                  });
                                                } else {
                                                  typeof window !== "undefined" &&
                                                    localStorage.setItem("redirectUrl", window.location.href);
                                                   window.location.assign(process.env.GATSBY_MAIN_SITE_REDIRECT +"/members/login");
                                                }
                                              }}
                                              href="javascript:void(0)"
                                              class={`ms-3  dark-green-text text-decoration-underline bid ask-question `}
                                              data-bs-toggle="modal"
                                              data-bs-target="#askAquestion"
                                            >
                                              Ask a Question
                                            </a>{" "}
                                            {typeof window !== "undefined" &&
                                            localStorage.getItem("member") &&
                                            JSON.parse(localStorage.getItem("member")).sec_list != 100103 &&
                                            !isMobile
                                              ? "|"
                                              : ""}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {typeof window !== "undefined" &&
                                          localStorage.getItem("member") &&
                                          JSON.parse(localStorage.getItem("member")).sec_list != 100103 &&
                                          product?.trader?.length > 0 &&
                                          !pageContext.archive && (
                                            <a
                                              href="javascript:void(0)"
                                              onClick={(e) => {
                                                setLoadingToken(true);
                                                setShowChatModal(true);
                                                checkToken((res) => {
                                                  if (res && res.status == 200) {
                                                    e.preventDefault();
                                                    setLoadingToken(false);
                                                  }
                                                });
                                              }}
                                              class={
                                                isMobile
                                                  ? ` dark-green-text text-decoration-underline  bid ml-1`
                                                  : ` ms-3  dark-green-text text-decoration-underline  bid ml-1`
                                              }
                                            >
                                              Chat with Us
                                            </a>
                                          )}
                                      </>
                                    )}
                                  </td>
                                </tr> */}
                                {(!product.image || (pageContext.archive && !product.primaryPicture)) &&
                                  detail.c_company && (
                                    <tr>
                                      <td style={{ width: "200px" }}>
                                        {loadingDetail ? <Skeleton height={15} width={100} /> : "Trader"}
                                      </td>
                                      {!loadingDetail && <td>:</td>}
                                      <td>{loadingDetail ? <Skeleton height={15} width={100} /> : detail.c_company}</td>
                                    </tr>
                                  )}
                                {detail?.detail?.loading_costs_feature && detail?.detail?.loading_costs?.length > 0 && (
                                  <tr>
                                    <td style={{ width: "200px" }}>
                                      {loadingDetail ? <Skeleton height={15} width={100} /> : "Loading Cost"}
                                    </td>
                                    {!loadingDetail && <td>:</td>}
                                    <td>
                                      {loadingDetail ? (
                                        <Skeleton height={15} width={100} />
                                      ) : (
                                        detail?.detail?.loading_costs
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            )}
                          </table>
                        )}
                      </div>
                    </div>
                    {tab !== "bid" && !loadingMain ? (
                      <>
                        {product.image || (pageContext.archive && product.primaryPicture) ? (
                          detail && detail.detail && detail.detail.details ? (
                            <div class={`  pd-box table-details-fix  table auction-table-seller-fix  `}>
                              <h4>{at_id !== 6 ? `Seller` : ""} Description</h4>
                              <div
                                className={` seller-description-scroll sustainability-product-detail-fix dot-list-fix dot-list customized-bullet table-seller-detail   d-flex flex-column `}
                              >
                                {product.image || (pageContext.archive && product.primaryPicture)
                                  ? detail && detail.detail && detail.detail.details && parse(detail.detail.details)
                                  : detail && detail.detail && detail.detail.details && parse(detail.detail.details)}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : detail && detail?.detail?.details ? (
                          <div class={` pd-box table-details-fix table `}>
                            <h4>{at_id !== 6 ? `Seller` : ""} Description</h4>
                            <div
                              className={` seller-description-scroll sustainability-product-detail-fix dot-list-fix dot-list customized-bullet table-seller-detail  d-flex flex-column `}
                            >
                              {product.image || (pageContext.archive && product.primaryPicture)
                                ? detail && detail.detail && detail.detail.details && parse(detail.detail.details)
                                : detail && detail.detail && detail.detail.details && parse(detail.detail.details)}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(product.image ||
                          (pageContext.archive && product.primaryPicture) ||
                          (detail && detail?.detail?.details)) &&
                          at_id !== 6 && (
                            <div class={` pd-box`}>
                              <h4>Seller Terms</h4>
                              <ul class={` dot-list dot-list-fix customized-bullet`}>
                                <li>Salvex and the seller have the right to reject any and all offers.</li>
                                <li>
                                  This product is sold <strong>AS IS, WHERE IS.</strong>
                                </li>
                                <li>Buyer is responsible for all taxes, duties, loading and freight charges.</li>
                                <li>Seller does not offer any warranties or manufacturer warranties.</li>
                                <li>
                                  Upon receipt of cleared funds, Seller will provide the Buyer a Release Order for item
                                  pick up. Title transfers from Seller to Buyer upon issuance of the Release Order.
                                </li>
                                <li>
                                  It is{" "}
                                  <strong>
                                    Buyer's responsibility to verify quantities and condition at the time of pick up.
                                  </strong>{" "}
                                  Once the product has been removed from Seller's location, there will be no adjustments
                                  based on quantity or condition.
                                </li>
                              </ul>
                            </div>
                          )}
                      </>
                    ) : typeof window !== "undefined" && localStorage.getItem("token") ? (
                      ""
                    ) : (
                      <div class={` pd-box`}>
                        <div class={` tab-pane-form`}>
                          <h4>Not a Member?</h4>
                          <p>To place bids or to sell items on this site, you must first become a member.</p>
                          <strong>Member Benefits</strong>
                          <ul class={` dot-list`}>
                            <li>Place bids on each of our Regular Auctions or Bid ASAP Auctions.</li>
                            <li>Receive Auction Alerts fitting your buying preferences.</li>
                            <li>List items in each of our selling formats (i.e. Auction, BID ASAP, etc.).</li>
                            <li>Reach a wider audience of customers.</li>
                          </ul>
                          <div class={` form-group form-button  `}>
                            <input
                              type="submit"
                              name="register"
                              class="btn btn-default btn-xl  btn-block "
                              value="Register"
                              onClick={() => {
                                if (typeof window !== "undefined") {
                                  window.location.href = "/members/register";
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {!loadingDetail && !_.isEmpty(descpCard) && descpCard.ai_description && (
                      <div class={` pd-box`}>
                        <h4>AI Product Description</h4>
                        <p className={` descp-pre-line`}>{parse(descpCard.ai_description)}</p>
                      </div>
                    )}

                    {!loadingDetail && !_.isEmpty(descpCard) && descpCard.mfr_description && (
                      <div class={` pd-box`}>
                        <h4>AI Manufacturer Description</h4>
                        <p className={` descp-pre-line`}>{parse(descpCard.mfr_description)}</p>
                      </div>
                    )}

                    {!loadingDetail && !_.isEmpty(descpCard) && descpCard.co_description && (
                      <div class={` pd-box`}>
                        <h4>AI Carbon Footprint Explanation</h4>
                        <p className={` descp-pre-line`}>{parse(descpCard.co_description)}</p>
                        <br />
                        <p>
                          Repurposing commercial products is good for the environment because it creates Manufacture
                          Avoidance. We try to measure the amount of carbon it takes to build this asset and by
                          repurposing, we are creating an Manufacture Avoidance Carbon Offset.{" "}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {showHelp && showAviation ? (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class={` psr-header d-flex align-items-center justify-content-between`}>
              <h4>Aircraft Parts</h4>
            </div>
            <Suspense fallback={<div></div>}>
              <AviationTable
                location={location}
                showAddPart={showAddPart}
                toggleAddPart={toggleAddPart}
                page={"auctionDetail"}
                aucid={aucID}
              />
            </Suspense>
          </div>
        ) : showAviation ? (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class={` psr-header d-flex align-items-center justify-content-between`}>
              <h4> Parts</h4>
            </div>
            <Suspense fallback={<div></div>}>
              <PartsTable
                location={location}
                showAddPart={showAddPart}
                toggleAddPart={toggleAddPart}
                page={"auctionDetail"}
                aucid={aucID}
              />
            </Suspense>
          </div>
        ) : (
          ""
        )}
        {wantedListings && wantedListings?.length > 0 && (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class={` psr-header d-flex align-items-center justify-content-between`}>
                    <h4>Other Wanted Listings in {cat}</h4>
                    <a
                      href={subCatid == "9999" ? `/pipe` : `/listings/index.cfm/wanted`}
                      class={` viewall`}
                      style={{
                        textDecoration: "underline",
                        color: "#47ad1d",
                      }}
                    >
                      View All
                    </a>
                  </div>
                  <ul class={` gridview d-flex flex-wrap`}>
                    {wantedListings.map((e) => (
                      <div class="grid7-card-item other-listing-detail">
                        <div
                          class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start cursor-pointer"
                          onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`)}
                        >
                          <div class="grid7-card-img-box overflow-hidden">
                            <img src={e.image} alt={e.title} />
                          </div>
                          <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                            <div class="grid7-card-title">{e.title}</div>
                            <div class="grid7-card-subtitle">{e.category}</div>
                            {e?.asking_price > 0 ? (
                              <div class="grid7-offer d-flex flex-column align-items-start">
                                <div class="offer-label">Current Asking Price</div>
                                <div class="offer-total">
                                  ${" "}
                                  {parseFloat(Math.trunc(e.asking_price))
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {e?.wholesale_value > 0 ? (
                              <div class="grid7-highlighted-content w-100">
                                <div class="g-h-label">Wholesale Value</div>
                                <div class="g-h-total">
                                  <span>
                                    $
                                    {parseFloat(Math.trunc(e.wholesale_value))
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div class="grid7-cans">
                              {e.quantity} {e.unit}
                            </div>
                            <div class="grid7-location">{e.location ? e.location : "Global"}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        {subCat && subListings.length > 0 && (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class={` psr-header d-flex align-items-center justify-content-between`}>
                    <h4>Other Listings in {subCat}</h4>
                    <a
                      href={subCatid == "9999" ? `/pipe` : `/listings/index.cfm/catid/${subCatid}`}
                      class={` viewall`}
                      style={{
                        textDecoration: "underline",
                        color: "#47ad1d",
                      }}
                    >
                      View All
                    </a>
                  </div>
                  <ul class={` gridview d-flex flex-wrap`}>
                    {subListings.map((e) => (
                      <div class="grid7-card-item other-listing-detail">
                        <div
                          class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start cursor-pointer"
                          onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`)}
                        >
                          <div class="grid7-card-img-box overflow-hidden">
                            <img src={e.image} alt={e.title} />
                            <div
                              class={`  bid-intro-box bid-intro-box-1 light-green  d-flex align-items-center justify-content-center`}
                            >
                              <h4 style={{ fontSize: "0.75rem" }}>{isWantedPipe ? "Send a Quote" : "Place a Bid"}</h4>
                            </div>
                          </div>
                          <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                            <div class="grid7-card-title">{e.title}</div>
                            <div class="grid7-card-subtitle">{e.category}</div>
                            {e?.asking_price > 0 ? (
                              <div class="grid7-offer d-flex flex-column align-items-start">
                                <div class="offer-label">Current Asking Price</div>
                                <div class="offer-total">
                                  ${" "}
                                  {parseFloat(Math.trunc(e.asking_price))
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </div>
                                <div
                                  class="offer-badge"
                                  onClick={(ed) => {
                                    ed.preventDefault();
                                    ed.stopPropagation();
                                    navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`, {
                                      state: { buyNowClicked: true },
                                    });
                                  }}
                                >
                                  Buy Now or Counter Offer
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {e?.wholesale_value > 0 ? (
                              <div class="grid7-highlighted-content w-100">
                                <div class="g-h-label">Wholesale Value</div>
                                <div class="g-h-total">
                                  <span>
                                    $
                                    {parseFloat(Math.trunc(e.wholesale_value))
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div class="grid7-cans">
                              {e.quantity} {e.unit}
                            </div>
                            <div class="grid7-location">{e.location}</div>
                            {e.bid_count > 0 ? (
                              <div class="grid7-badge">
                                {e.bid_count} {e.bid_count == "1" || e.bid_count == "0" ? "Bid" : "Bids"}
                              </div>
                            ) : (
                              <div class="grid7-badge">0 Bid</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        {cat && listings && listings.length > 0 && (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class={` psr-header d-flex align-items-center justify-content-between`}>
                    <h4>Other Listings in {cat}</h4>
                    <a
                      href={catid == "9999" ? "/pipe" : `/listings/index.cfm/catid/${catid}`}
                      class={` viewall`}
                      style={{
                        textDecoration: "underline",
                        color: "#47ad1d",
                      }}
                    >
                      View All
                    </a>
                  </div>
                  <ul class={` gridview d-flex flex-wrap`}>
                    {listings.map((e) => (
                      <div class="grid7-card-item other-listing-detail">
                        <div
                          class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start cursor-pointer"
                          onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`)}
                        >
                          <div class="grid7-card-img-box overflow-hidden">
                            <img src={e.image} alt={e.title} />
                            <div
                              class={`  bid-intro-box bid-intro-box-1 light-green  d-flex align-items-center justify-content-center`}
                            >
                              <h4 style={{ fontSize: "0.75rem" }}>{isWantedPipe ? "Send a Quote" : "Place a Bid"}</h4>
                            </div>
                          </div>
                          <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                            <div class="grid7-card-title">{e.title}</div>
                            <div class="grid7-card-subtitle">{e.category}</div>
                            {e.asking_price > 0 ? (
                              <div class="grid7-offer d-flex flex-column align-items-start">
                                <div class="offer-label">Current Asking Price</div>
                                <div class="offer-total">
                                  ${" "}
                                  {parseFloat(Math.trunc(e.asking_price))
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </div>
                                <div
                                  class="offer-badge"
                                  onClick={(ed) => {
                                    ed.preventDefault();
                                    ed.stopPropagation();
                                    navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  }}
                                >
                                  Buy Now or Counter Offer
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {e.wholesale_value > 0 ? (
                              <div class="grid7-highlighted-content w-100">
                                <div class="g-h-label">Wholesale Value</div>
                                <div class="g-h-total">
                                  <span>
                                    $
                                    {parseFloat(Math.trunc(e.wholesale_value))
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div class="grid7-cans">
                              {e.quantity} {e.unit}
                            </div>
                            <div class="grid7-location">{e.location}</div>
                            {e.bid_count > 0 ? (
                              <div class="grid7-badge">
                                {e.bid_count} {e.bid_count == "1" || e.bid_count == "0" ? "Bid" : "Bids"}
                              </div>
                            ) : (
                              <div class="grid7-badge">0 Bid</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        {!loadingHistory && !loadingDetail && historyData?.length > 0 ? (
          <div class={` product-slider-row white-bg  overflow-hidden`}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class={` psr-header d-flex align-items-center justify-content-between`}>
                    <h4>Browsing History</h4>
                  </div>
                  <ul class={` gridview d-flex flex-wrap`}>
                    {historyData.map((e) => (
                      <div class="grid7-card-item other-listing-detail">
                        <div
                          class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start cursor-pointer"
                          onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`)}
                        >
                          <div class="grid7-card-img-box overflow-hidden">
                            <img src={e.primary_photo} alt={e.title} />
                            <div
                              class={`  bid-intro-box bid-intro-box-1 light-green  d-flex align-items-center justify-content-center`}
                            >
                              <h4 style={{ fontSize: "0.75rem" }}>Place a Bid</h4>
                            </div>
                          </div>
                          <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                            <div class="grid7-card-title">{e.title}</div>
                            <div class="grid7-card-subtitle">{e.cat_description}</div>
                            {e?.public_asking_price > 0 ? (
                              <div class="grid7-offer d-flex flex-column align-items-start">
                                <div class="offer-label">Current Asking Price</div>
                                <div class="offer-total">
                                  ${" "}
                                  {parseFloat(Math.trunc(e.public_asking_price))
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </div>
                                <div
                                  class="offer-badge"
                                  onClick={(ed) => {
                                    ed.preventDefault();
                                    ed.stopPropagation();
                                    navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  }}
                                >
                                  Buy Now or Counter Offer
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {e?.wholesale_value > 0 ? (
                              <div class="grid7-highlighted-content w-100">
                                <div class="g-h-label">Wholesale Value</div>
                                <div class="g-h-total">
                                  <span>
                                    $
                                    {parseFloat(Math.trunc(e.wholesale_value))
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div class="grid7-cans">
                              {e.quantity} {e.unit}
                            </div>
                            <div class="grid7-location">{e.location2}</div>
                            {e.bidsCount > 0 ? (
                              <div class="grid7-badge">
                                {e.bidsCount} {e.bidsCount == "1" || e.bidsCount == "0" ? "Bid" : "Bids"}
                              </div>
                            ) : (
                              <div class="grid7-badge">0 Bid</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={` detail-page-text`}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className={` text-wrapper-div`}>
                  {" "}
                  {category_meta && category_meta.content_full ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: category_meta?.content_full
                          .replace(/<\/?[^>]+(>|$)/g, "")
                          .replace("#FFFFFF", "#0b0000"),
                      }}
                    ></p>
                  ) : (
                    ""
                  )}
                  <p>
                    Salvex handles surplus, bankruptcy, overruns, obsolete inventory, disposal, insurance claims, online
                    auctions, liquidation sale, foreclosure, lockout, seized, scrap, salvage, new, used, damaged,
                    refurbished, and asset recovery.
                  </p>
                  <p>Repurposing commercial assets creates carbon offsets and sustainability corporate solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!loadingMain &&
          tab !== "bid" &&
          !showChatModal &&
          detail.detail &&
          detail.detail.status_id &&
          parseInt(detail.detail.status_id) < 4 && (
            <div className={` mob-filter-btn-group d-lg-none d-flex align-items-center`}>
              <a
                href="javascript:void(0)"
                className={` filter-btn d-flex align-items-center justify-content-center  sidebar_toggler`}
                data-toggle="filter-box"
                onClick={(e) => {
                  e.preventDefault();
                  if (token) {
                    setLoadingToken(true);
                    setTab("bid");
                    checkToken((res) => {
                      window.scrollTo({
                        top: mobileBidRef.current.offsetTop - 150,
                        behavior: "smooth",
                      });
                      if (res && res.status == 200) {
                        setLoadingToken(false);
                      }
                    });
                  } else {
                    setTab("bid");
                    window.scrollTo({
                      top: mobileBidRef.current.offsetTop - 150,
                      behavior: "smooth",
                    });
                  }
                }}
              >
                + {isWantedPipe ? "Send a Quote" : "Place a Bid"}
              </a>
            </div>
          )}
        <Suspense fallback={<div></div>}>
          <Footer />
        </Suspense>
      </div>
      <Suspense fallback={<div></div>}>
        <LowerAskingPrice
          show={askingPriceModal}
          onHide={toggleAskingPrice}
          title={product.title}
          isWantedPipe={isWantedPipe}
          product={product}
          loadData={loadData}
          setBidPlaced={setBidPlaced}
          detail={detail}
          loadingToken={loadingToken}
        />
        <AskQuestionModal
          show={show}
          handleClose={handleClose}
          product={{ ...product, title: product?.title ? product?.title : detail?.title ? detail?.title : "" }}
          detail={detail}
          loadingToken={loadingToken}
        />
        <ShareWithMyBuyers show={showBuyerModal} onHide={toggleBuyerModal} listing={selectedListing} />

        <ImageLargeModal
          show={imgShow}
          handleClose={handleImgShow}
          items={items}
          startIndex={photoIndex}
          title={product?.title}
        />
      </Suspense>

      {/* <div className="modal-backdrop fade ">Loading</div> */}
    </>
  );
};

export default ProductDetails;
